import {connect} from 'react-redux'
import Tracks from '../components/Tracks.jsx'
import {
  playTrack,
  setPlayback
} from '../../../actions/Actions.js'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    track: state && state.radio && state.radio.track !== undefined
      ? state.radio.track
      : -1,
    tracks: state && state.radio && state.radio.tracks !== undefined
      ? state.radio.tracks
      : [],
    playback: state && state.radio && state.radio.playback !== undefined
      ? state.radio.playback
      : 0
  }
}

// Map Redux actions to component props
function mapDispatchToProps (dispatch) {
  return {
    onPlayTrack: (i) => dispatch(playTrack(i)),
    onSetPlayback: (i) => dispatch(setPlayback(i))
  }
}

// Connected Component
const TracksContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Tracks)

export default TracksContainer
